export default __webpack_public_path__ + "static/media/AvertaStdCY-Semibold.b5f7fb73.otf";